var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStripeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 370.5 158.1",
    style: {
      enableBackground: "new 0 0 370.5 158.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M365,82c0-25.6-12.4-45.8-36.1-45.8c-23.8,0-38.2,20.2-38.2,45.6c0,30.1,17,45.3,41.4,45.3 c11.9,0,20.9-2.7,27.7-6.5v-20c-6.8,3.4-14.6,5.5-24.5,5.5c-9.7,0-18.3-3.4-19.4-15.2h48.9C364.8,89.6,365,84.4,365,82z  M315.6,72.5c0-11.3,6.9-16,13.2-16c6.1,0,12.6,4.7,12.6,16H315.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M252.1,36.2c-9.8,0-16.1,4.6-19.6,7.8l-1.3-6.2h-22v116.6l25-5.3l0.1-28.3c3.6,2.6,8.9,6.3,17.7,6.3 c17.9,0,34.2-14.4,34.2-46.1C286.1,52,269.6,36.2,252.1,36.2z M246.1,105.1c-5.9,0-9.4-2.1-11.8-4.7l-0.1-37.1 c2.6-2.9,6.2-4.9,11.9-4.9c9.1,0,15.4,10.2,15.4,23.3C261.5,95.1,255.3,105.1,246.1,105.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "174.8,30.3 199.9,24.9 199.9,4.6 174.8,9.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.8,
    y: 37.9,
    className: "st0",
    width: 25.1,
    height: 87.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147.9,45.3l-1.6-7.4h-21.6v87.5h25V66.1c5.9-7.7,15.9-6.3,19-5.2v-23C165.5,36.7,153.8,34.5,147.9,45.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.9,16.2l-24.4,5.2l-0.1,80.1c0,14.8,11.1,25.7,25.9,25.7c8.2,0,14.2-1.5,17.5-3.3v-20.3 c-3.2,1.3-19,5.9-19-8.9V59.2h19V37.9h-19L97.9,16.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.3,63.3c0-3.9,3.2-5.4,8.5-5.4c7.6,0,17.2,2.3,24.8,6.4V40.8c-8.3-3.3-16.5-4.6-24.8-4.6 C18.5,36.2,5,46.8,5,64.5c0,27.6,38,23.2,38,35.1c0,4.6-4,6.1-9.6,6.1c-8.3,0-18.9-3.4-27.3-8v23.8c9.3,4,18.7,5.7,27.3,5.7 c20.8,0,35.1-10.3,35.1-28.2C68.4,69.2,30.3,74.5,30.3,63.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeLogo);
export default __webpack_public_path__ + "static/media/StripeLogo.1477c2636dc536b67c4c4712aa803d4b.svg";
export { ForwardRef as ReactComponent };